import { useMutation } from "@tanstack/react-query";

import useApiHelper from "../hooks/useApiHelper";
import apiConfig from "../utils/apiConfig";

export interface IOrderGeneratorPayload {
  emailId: string;
  data: FormData;
}

// Public-facing order/requirements submission. Uses the same `customerPostFormData`
// pattern as `useCustomerUpload` so attached documents flow through as multipart.
// TODO(backend): wire `/customer/order-request` on the API.
export default function useOrderGenerator(componentName = "useOrderGenerator") {
  const { customerPostFormData } = useApiHelper(apiConfig(componentName));

  const submit = useMutation((body: IOrderGeneratorPayload) =>
    customerPostFormData(`/customer/order-request`, body)
  );

  return {
    submit,
  };
}
